import { ReactComponent as DeliveryNoteIcon } from 'assets/dialogue-avatar-delivery-note.svg';
import { DialogueCardData, DialogueType } from 'models/DialogCard';
import { TimeWindow, TimeWindowOnTimeStatusEnum } from 'models/shipments';

const TimeWindowEarlyCard: DialogueCardData = {
  analyticsId: 'timeWindowEarly',
  type: DialogueType.DELIVERY_NOTE,
  icon: <DeliveryNoteIcon />,
  title: 'We’re running ahead of schedule today',
  content: <p>Your parcel will likely arrive sooner than expected.</p>,
};

const TimeWindowLateCard: DialogueCardData = {
  analyticsId: 'timeWindowLate',
  type: DialogueType.DELIVERY_NOTE,
  icon: <DeliveryNoteIcon />,
  title: 'We’re running behind schedule today',
  content: <p>Your parcel will likely arrive later than expected.</p>,
};

export function getTimeWindowCard(timeWindow: TimeWindow | null) {
  const { passedWindow, onTimeStatus } = timeWindow || {};
  if (passedWindow || !onTimeStatus) return null;
  if (onTimeStatus === TimeWindowOnTimeStatusEnum.EARLIER) return TimeWindowEarlyCard;
  if (onTimeStatus === TimeWindowOnTimeStatusEnum.LATE) return TimeWindowLateCard;
  return null;
}
